"use client"

import Link from "next/link"
import { useRouter } from "next/navigation"
import { motion, AnimatePresence } from "motion/react"
import { Home, ArrowLeft } from "lucide-react"

export function NotFound() {
  const router = useRouter()

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0F0F12] px-4">
      <AnimatePresence mode="wait">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0, transition: { duration: 0.6, staggerChildren: 0.08 } }}
          exit={{ opacity: 0 }}
        >
          {/* 404 com fantasma */}
          <div className="flex items-center justify-center gap-4 md:gap-8 mb-10">
            <motion.span
              className="text-[80px] md:text-[120px] font-black text-white select-none leading-none opacity-70"
              initial={{ opacity: 0, x: -40, rotate: -6 }}
              animate={{ opacity: 0.7, x: 0, rotate: 0, transition: { duration: 0.7, ease: "easeOut" } }}
            >
              4
            </motion.span>

            <motion.div
              initial={{ scale: 0.7, opacity: 0, y: 10 }}
              animate={{
                scale: 1,
                opacity: 1,
                y: [0, -8, 0],
                transition: {
                  scale: { duration: 0.6, ease: "easeOut" },
                  opacity: { duration: 0.6 },
                  y: { duration: 2.2, ease: "easeInOut", repeat: Infinity, repeatType: "reverse", delay: 0.6 },
                },
              }}
              className="flex items-center justify-center"
            >
              {/* Fantasma SVG inline */}
              <svg
                viewBox="0 0 120 130"
                className="w-[72px] h-[72px] md:w-[110px] md:h-[110px]"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 60 C10 30 35 10 60 10 C85 10 110 30 110 60 L110 110 L95 100 L80 110 L65 100 L50 110 L35 100 L20 110 L10 110 Z"
                  fill="#7C3AED"
                  opacity="0.9"
                />
                <ellipse cx="43" cy="58" rx="9" ry="11" fill="white" />
                <ellipse cx="77" cy="58" rx="9" ry="11" fill="white" />
                <circle cx="46" cy="60" r="5" fill="#1a1a2e" />
                <circle cx="80" cy="60" r="5" fill="#1a1a2e" />
                <circle cx="48" cy="57" r="2" fill="white" />
                <circle cx="82" cy="57" r="2" fill="white" />
              </svg>
            </motion.div>

            <motion.span
              className="text-[80px] md:text-[120px] font-black text-white select-none leading-none opacity-70"
              initial={{ opacity: 0, x: 40, rotate: 6 }}
              animate={{ opacity: 0.7, x: 0, rotate: 0, transition: { duration: 0.7, ease: "easeOut" } }}
            >
              4
            </motion.span>
          </div>

          {/* Título */}
          <motion.h1
            className="text-2xl md:text-4xl font-bold text-white mb-3 select-none"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.2, ease: "easeOut" } }}
          >
            Página não encontrada
          </motion.h1>

          <motion.p
            className="text-base md:text-lg text-gray-400 mb-10 max-w-md mx-auto select-none"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.3, ease: "easeOut" } }}
          >
            Esta página ainda não existe ou está sendo implementada.
            Enquanto isso, continuamos capturando promoções! 👻
          </motion.p>

          {/* Botões */}
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.4, ease: "easeOut" } }}
            className="flex flex-col sm:flex-row items-center justify-center gap-3"
          >
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.97 }}>
              <Link
                href="/dashboard-cms"
                className="inline-flex items-center gap-2 bg-violet-600 hover:bg-violet-700 text-white px-6 py-3 rounded-xl text-sm font-semibold transition-colors"
              >
                <Home className="h-4 w-4" />
                Ir para o Dashboard
              </Link>
            </motion.div>

            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.97 }}>
              <button
                onClick={() => router.back()}
                className="inline-flex items-center gap-2 border border-gray-700 hover:border-gray-500 text-gray-300 hover:text-white px-6 py-3 rounded-xl text-sm font-semibold transition-colors"
              >
                <ArrowLeft className="h-4 w-4" />
                Voltar
              </button>
            </motion.div>
          </motion.div>

          {/* PromoBot badge */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { delay: 0.6, duration: 0.5 } }}
            className="mt-12"
          >
            <span className="text-xs text-gray-600 select-none">
              Sistema de captura de promoções
            </span>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
